module.exports = __webpack_public_path__ + "img/suha-logo.0a9caf1f.png";